import { MepLevelInfoCardBanner } from '@/features';
import { tw } from '@/common';

export type MepPlanActivationLevel = (typeof mepPlanActivationLevels)[number];
export const mepPlanActivationLevels = ['advice', 'watch-and-act', 'emergency-warning'] as const;

export const activationLevelBanner: Record<(typeof mepPlanActivationLevels)[number], MepLevelInfoCardBanner> = {
  advice: {
    text: 'Advice',
    backgroundColor: tw`bg-[#FBE032]`,
  },
  'watch-and-act': {
    text: 'Watch and Act',
    backgroundColor: tw`bg-[#FF7900]`,
  },
  'emergency-warning': {
    text: 'Emergency Warning',
    backgroundColor: tw`bg-[#D6001C]`,
    textColor: tw`fill-white text-white`,
  },
};

export const mepCompletedViewMarginXNormal = tw`mx-8 2xs:mx-12 sm:mx-14 md:mx-16 lg:mx-[88px]`;

export const mepCompletedViewMarginXLarge = tw`mx-12 3xs:mx-16 2xs:mx-20 sm:mx-[88px] md:mx-24 lg:mx-[120px]`;

export const mepCompletedViewMarginXTable = tw`px-6 3xs:px-10 2xs:px-14 sm:px-16 md:px-header lg:px-24`;
